export const ALLOWED_INQUIRY_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'application/pdf',
]

export const BLOCKED_EXECUTABLE_EXTENSIONS = [
  '.exe',
  '.js',
  '.mjs',
  '.cjs',
  '.bat',
  '.cmd',
  '.sh',
  '.php',
  '.py',
  '.rb',
  '.pl',
  '.jar',
  '.war',
  '.ps1',
  '.vbs',
  '.wsf',
  '.dll',
  '.so',
  '.dylib',
  '.com',
  '.scr',
  '.pif',
]
